import { WP_REST_API_Post } from 'wp-types';
import { StyledIndexBox, StyledIndexContent } from './PostIndex.styled';
import { useI18n } from 'hooks/useI18n';

export interface Anchor {
  headerLevel: 2;
  title: string;
  id: string;
}

export function extractH2(html: string): {
  processedHtml: string;
  anchors: Anchor[];
} {
  const anchors: Anchor[] = [];
  const h2Regex = /<h2\b([^>]*)>([\s\S]*?)<\/h2>/gi;
  const processedHtml = html.replace(
    h2Regex,
    (_match, attrs = '', innerHTML) => {
      const textOnly = innerHTML.replace(/<[^>]+>/g, '').trim();
      const id = slugify(textOnly);
      anchors.push({ headerLevel: 2, title: textOnly, id });
      const alreadyHasId = /\bid\s*=/.test(attrs);
      const newAttrs = alreadyHasId ? attrs : `${attrs} id="${id}"`;
      return `<h2${newAttrs}>${innerHTML}</h2>`;
    }
  );
  return { processedHtml, anchors };
}

function slugify(str: string): string {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
}

type PostIndexProps = { post: WP_REST_API_Post };

export const PostIndex: React.FC<PostIndexProps> = ({ post }) => {
  const { t } = useI18n('blog');
  const { anchors } = extractH2(post.content.rendered);
  return (
    <StyledIndexBox>
      <StyledIndexContent>
        <strong>{t('index.title')}</strong>
        <ul>
          {anchors.map(({ id, title }) => (
            <li key={id}>
              <span className="dash">—</span>
              <a href={`#${id}`}>{title}</a>
            </li>
          ))}
        </ul>
      </StyledIndexContent>
    </StyledIndexBox>
  );
};
